import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import StsA360RegStep2UsernamePostModel from '../../../models/sts-a360-reg-step2-username-post.model';
import { StsNotificationType } from '../../../models/sts-notification-type';
import { StsNotification } from '../../../models/sts-notification.model';
import { StsPortalStatus } from '../../../models/sts-portal-status';
import { StsRegexBluePrintModel } from '../../../models/sts-regex-blue-print.model';
import { StsTenant } from '../../../models/sts-tenant.model';
import { StsA360RegServicesService } from '../../../services/sts-a360-reg-services.service';
import { StsPortalStatusService } from '../../../services/sts-portal-status.service';
import { StsTenantService } from '../../../services/sts-tenant.service';
import { StsTfaRegServiceService } from '../../../services/sts-tfa-reg-service.service';
import {StsUserService} from "../../../services/sts-user.service";
import {StsUser} from "../../../models/sts-user.model";
import StsA360NotificationTokenModel from 'app/models/sts-a360-notification-token.model';


@Component({
  selector: 'app-account-reg-confirm-email',
  templateUrl: './account-reg-confirm-email.component.html',
  styleUrls: ['./account-reg-confirm-email.component.scss']
})
export class AccountRegConfirmEmailComponent implements OnInit {

  public model: StsA360RegStep2UsernamePostModel = new StsA360RegStep2UsernamePostModel();
  public errors: StsNotification[] = [];
  public signUpForm: FormGroup;
  public tenantInfo: StsTenant = new StsTenant();
  public triggerValidateEmitter: EventEmitter<void> = new EventEmitter<void>();
  public emailIsValid = true;
  public submitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  public changeUserId: boolean = false;

  message: StsA360NotificationTokenModel;

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  constructor(private tfa: StsTfaRegServiceService,
              private regService: StsA360RegServicesService,
              private userService: StsUserService,
              private portalStatusService: StsPortalStatusService,
              private route: ActivatedRoute,
              private tenantService: StsTenantService,
              public fb: FormBuilder,
              private tntInfo: StsTenantService,
              private router: Router) {

    this.route.params.subscribe(params => {
      this.changeUserId = params['changeUserId'] === 'true';


      this.tenantService.getTenantSource().subscribe(tenant => {
        this.tenantInfo = tenant;

        this.portalStatusService.getPortalStatus().subscribe(
          (portalStatus: StsPortalStatus) => {
            let isSelfRegFlow = portalStatus.isSelfRegFlow;

            if ((!params['id'] || !isSelfRegFlow) && !(params['linkFromEmail']==='true')) {
              console.log('User attempting to execute \'set username\' without permission! Redirecting to login.');
              this.router.navigateByUrl('/account/signin');
              return;
            }
            this.model = new StsA360RegStep2UsernamePostModel();
            this.model.id = params['id'];
            if(params['linkFromEmail']==='true'){
              regService.getPersonalEmail(params['id']).subscribe(rs => {
                if(rs.errors==undefined||rs.errors.length==0){
                  let fc = this.signUpForm.controls['emailInput'] as FormControl;
                  fc.setValue(rs.info.personalEmail);
                  this.model.id = rs.info.id;
                }
                else{
                    let err = new StsNotification();
                    let e = rs.errors[0];
                    err.code = rs.errors[0];
                    err.description = rs.errors[0];
                    err.level = StsNotificationType.Error;
                    this.errors=[err];
                }
              }
              );
            }
            else
            {
              if(this.message.PersonalEmail){
                let fc = this.signUpForm.controls['emailInput'] as FormControl;
                fc.setValue(this.message.PersonalEmail);
              }
            }
          });
      });

      this.signUpForm = this.fb.group({

        emailInput: new FormControl('',
          {
            validators: [
              (c: FormControl) => {
                if (!c.value) {
                  return {
                    emailRequired: {
                      valid: false
                    }
                  };
                }
                let re = atob(this.tenantInfo.usefulPatterns['email'] + '');
                re = re.replace(/(^\\A)|(\\Z$)/g, '');
                this.emailIsValid = (new RegExp(re)).test(c.value);
                return (new RegExp(re)).test(c.value) ? null : {
                  validateEmail: {
                    valid: false
                  }
                };
              },
              ] ,

            updateOn: 'submit'
          })
      });

     // this.resetFields();

    });

  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  public triggerValidation(v) {

    this.signUpForm.controls['emailInput'].updateValueAndValidity();
  }

  public resetFields() {

    this.signUpForm.controls['emailInput'].reset();
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  public gotoHome(): void {
    this.router.navigateByUrl('/');
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  getReType(re: string): StsRegexBluePrintModel {
    let tmp = new StsRegexBluePrintModel();
    re = re.replace(/(^\\A)|(\\Z$)/g, '');
    tmp.regexp = new RegExp(btoa(re));
    tmp.model = this.model;
    return tmp;
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  onSubmit(): void {
    this.submitter.emit(false);
    this.triggerValidation('');
    if (this.signUpForm.valid) {
      this.submitter.emit(true);
      this.errors = [];
      let n = new StsA360RegStep2UsernamePostModel();
      n.id = this.model.id;
      let user = new StsUser();
      user.id = n.id;
      n.email = this.signUpForm.controls['emailInput'].value;
      if (this.changeUserId) { // update user in ariel security db
        if(n.email)   user.hasEmailChanged = true;
        
        user.userName = n.email;
        this.userService.changeUserId(user).subscribe(data => {
          let url = '/account/forgot-username/';
          this.router.navigate([url, {newUserName:user.userName, userId:user.id}]);
        });
      }
      else { // register a new user in ariel360
        this.regService.postStep2Answers(n).subscribe(rs => {
          this.submitter.emit(false);
          if (rs.success) {
            this.tfa.setEmailAsVerified(n.email).subscribe(a => {
              if (a.success) {
                let url = '/account/password/new';
                this.router.navigate([url, { id: user.id }]);
              }
              else {
                let e = new StsNotification();
                e.code = rs['sts-code'] || rs.stsCode;
                e.level = StsNotificationType.Error;
                e.description = 'Failed registering the email';
                this.errors = [e];
              }
            });
          } else {
            let e = new StsNotification();
            e.code = rs['sts-code'] || rs.stsCode;
            e.level = StsNotificationType.Error;
            e.description = 'submitted data contains errors';
            this.errors = [e];
          }
        });
      }
    } else {
      let e = new StsNotification();
      e.code = 'sts-correct-username-errors';
      e.level = StsNotificationType.Error;
      e.description = 'submitted data contains errors';
      this.errors = [e];
    }
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  ngOnInit() {
    this.regService.currentMessage.subscribe(message => this.message = message);
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@





}

